import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Calendar as ReactCalendar } from 'react-big-calendar'

import WeekHeader from './WeekHeader'
import TimeSlot from './TimeSlot'
import MonthEvent from './MonthEvent'
import CalendarToolbar from './CalendarToolbar'
import AcceptClassDetails from './AcceptClassDetails'
import CancelClass from './CancelClass'
import CancelClassSuccess from './CancelClassSuccess'

import { getStudentCalendar } from 'routing/fetchingfunction/dashboard/dashboard.action'
import { selectRole } from '../../../routing/fetchingfunction/user/user.reducer'
import { selectStudentCalendarData } from '../../../routing/fetchingfunction/dashboard/dashboard.reducer'

import { calendarEventTypes, localizer, TUTOR_ROLE } from '../../../constants'

import './calendar.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import ChangeTime from './ChangeTime'
import ChangeTimeSuccess from './ChangeTime/ChangeTimeSuccess'

const fakeData = {
  '2023-08-18:9': {
    id: '2023-08-17:9',
    title: 'Metaverse',
    status: 'accepted',
  },
  '2023-08-18:10': {
    id: '2023-08-17:10',
    title: 'NFT',
    status: 'pending',
  },
}

const Calendar = () => {
  const dispatch = useDispatch()

  // do not delete this, it will re-render the calendar
  const userCalendarData = useSelector(selectStudentCalendarData)
  const role = useSelector(selectRole)

  const [isAcceptDetailsModalOpen, setIsAcceptDetailsModalOpen] = useState(false)
  const [acceptDetailsData, setAcceptDetailsData] = useState(null)
  const [cancelDetails, setCancelDetails] = useState(null)
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false)
  const [cancelSuccessDetails, setCancelSuccessDetails] = useState(null)
  const [isCancelSuccessModalOpen, setIsCancelSuccessModalOpen] = useState(false)
  const [changeTimeDetails, setChangeTimeDetails] = useState(null)
  const [isChangeTimeModalOpen, setIsChangeTimeModalOpen] = useState(false)
  const [changeTimeSuccessDetails, setChangeTimeSuccessDetails] = useState(null)
  const [isChangeTimeSuccessModalOpen, setIsChangeTimeSuccessModalOpen] = useState(false)
  // TODO: delete this
  const [isTimeChangeRequested, setIsTimeChangeRequested] = useState(false)

  const isTutor = role === TUTOR_ROLE

  const handleClickTimeSlot = (data) => {
    setIsAcceptDetailsModalOpen(true)
    setAcceptDetailsData(data.value)
  }

  const handleCloseAcceptDetailsModal = () => {
    setIsAcceptDetailsModalOpen(false)

    setTimeout(() => {
      setAcceptDetailsData(null)
    }, 300)
  }

  const handleOpenCancelModal = (data) => {
    setIsCancelModalOpen(true)
    setCancelDetails(data)
  }

  const handleCloseCancelModal = () => {
    setIsCancelModalOpen(false)

    setTimeout(() => {
      setCancelDetails(null)

      if (cancelDetails) {
        handleClickTimeSlot({ value: cancelDetails })
      }
    }, 300)
  }

  const handleOpenCancelSuccessModal = (data) => {
    setIsCancelModalOpen(false)

    setTimeout(() => {
      setCancelDetails(null)
      setIsCancelSuccessModalOpen(true)
      setCancelSuccessDetails(data)
    }, 300)
  }

  const handleCloseCancelSuccessModal = () => {
    setIsCancelSuccessModalOpen(false)

    setTimeout(() => {
      setCancelSuccessDetails(null)
    }, 300)
  }

  const handleOpenChangeTimeModal = (data) => {
    setIsChangeTimeModalOpen(true)
    setChangeTimeDetails({
      acceptDetailsData,
      data,
    })
  }

  const handleCloseChangeTimeModal = () => {
    setIsChangeTimeModalOpen(false)

    setTimeout(() => {
      setChangeTimeDetails(null)

      if (changeTimeDetails?.acceptDetailsData) {
        setIsAcceptDetailsModalOpen(true)
        setAcceptDetailsData(changeTimeDetails.acceptDetailsData)
      }
    }, 300)
  }

  const handleContinueChangeTime = (data) => {
    setIsChangeTimeModalOpen(false)

    setTimeout(() => {
      setChangeTimeDetails(null)

      handleOpenChangeTimeSuccessModal(data)
    }, 300)
  }

  const handleOpenChangeTimeSuccessModal = (data) => {
    setIsChangeTimeSuccessModalOpen(true)
    setChangeTimeSuccessDetails({
      data,
      acceptDetailsData: changeTimeDetails?.acceptDetailsData,
    })
  }

  const handleCloseChangeTimeSuccessModal = () => {
    setIsChangeTimeSuccessModalOpen(false)

    setTimeout(() => {
      setChangeTimeSuccessDetails(null)

      // TODO: delete this
      setIsTimeChangeRequested(true)

      if (changeTimeSuccessDetails?.acceptDetailsData) {
        setIsAcceptDetailsModalOpen(true)
        setAcceptDetailsData(changeTimeSuccessDetails.acceptDetailsData)
      }
    }, 300)
  }

  const calendarEventTypesContent = calendarEventTypes.map((calendarEventType) => {
    return (
      <div key={calendarEventType.name} className="flex items-center">
        <span
          aria-hidden
          style={{ backgroundColor: calendarEventType.color }}
          className="w-[20px] h-[20px] rounded-[4px]"
        />

        <span className="ml-[10px] text-primary-100 text-sm font-medium">
          {calendarEventType.name}
        </span>
      </div>
    )
  })

  useEffect(() => {
    // TODO dispatch based on the role
    dispatch(getStudentCalendar())
  }, [])

  return (
    <div className={`w-full ${isTutor ? 'min-h-[955px]' : 'min-h-[906px]'}`}>
      <div className="bg-primary-50 !p-6 rounded-lg">
        <ReactCalendar
          className="metaverse-calendar"
          views={['day', 'week', 'month']}
          selectable
          startAccessor="start"
          endAccessor="end"
          localizer={localizer}
          defaultDate={new Date()}
          defaultView="week"
          style={{ height: 726 }}
          onSelectEvent={(event) => console.log(event)}
          timeslots={1}
          step={60}
          components={{
            header: WeekHeader,
            toolbar: (data) => <CalendarToolbar {...data} />,
            timeSlotWrapper: (props) => {
              return <TimeSlot {...props} onClick={handleClickTimeSlot} />
            },
            month: {
              dateHeader: (props) => <MonthEvent {...props} data={fakeData} />,
            },
          }}
        />

        <div className="mt-[16px] flex items-center gap-x-[16px]">{calendarEventTypesContent}</div>
      </div>

      <AcceptClassDetails
        data={acceptDetailsData}
        open={isAcceptDetailsModalOpen}
        isTimeChangeRequested={isTimeChangeRequested}
        onClose={handleCloseAcceptDetailsModal}
        onOpenCancelModal={handleOpenCancelModal}
        onOpenChangeTimeModal={handleOpenChangeTimeModal}
      />

      <CancelClass
        data={cancelDetails}
        open={isCancelModalOpen}
        onClose={handleCloseCancelModal}
        onSuccess={handleOpenCancelSuccessModal}
      />

      <CancelClassSuccess
        open={isCancelSuccessModalOpen}
        data={cancelSuccessDetails}
        onClose={handleCloseCancelSuccessModal}
      />

      <ChangeTime
        open={isChangeTimeModalOpen}
        data={changeTimeDetails?.data}
        onClose={handleCloseChangeTimeModal}
        onContinue={handleContinueChangeTime}
      />

      <ChangeTimeSuccess
        open={isChangeTimeSuccessModalOpen}
        data={changeTimeSuccessDetails}
        onClose={handleCloseChangeTimeSuccessModal}
      />
    </div>
  )
}

export default Calendar
